import {HeadingNode, QuoteNode} from "@lexical/rich-text"
import {ListItemNode, ListNode} from "@lexical/list"
import {CodeHighlightNode, CodeNode} from "@lexical/code"
import {HorizontalRuleNode} from "@lexical/react/LexicalHorizontalRuleNode"
import {AutoLinkNode, LinkNode} from "@lexical/link"
import {ImageNode} from "./plugins/image/node/node"
import {MentionNode} from "./plugins/mentions/node/node"
import {BannerNode} from "./plugins/banner/node/banner-node"
import {BadgeNode} from "./plugins/highlight/badge/node/badge-node"
import {FontColorNode} from "./plugins/highlight/font-color/node/font-color-node"
import {PageBreakNode} from "./plugins/page-break/node/page-break"
import {EmojiNode} from "./plugins/emoji/node/emoji-node"
import {TableCellNode, TableNode, TableRowNode} from "@lexical/table"
import {LayoutItemNode} from "./plugins/layout/node/item-node"
import {LayoutContainerNode} from "./plugins/layout/node/container-node"
import {CollapsibleContainerNode} from "./plugins/collapse-container/node/container-node"
import {CollapsibleContentNode} from "./plugins/collapse-container/node/content-node"
import {CollapsibleTitleNode} from "./plugins/collapse-container/node/title-node"
import {YouTubeNode} from "./plugins/embed/youtube/node/youtube-node"
import {FigmaNode} from "./plugins/embed/figma/node/figma-node"
import {AttachmentNode} from "./plugins/attachment/node/node"
import {ParagraphNode} from "lexical"
import {CustomParagraphNode} from "./plugins/paragraph/paragraph-node"

export const TextareaNodes = [
    HeadingNode,
    ListNode,
    ListItemNode,
    QuoteNode,
    CodeNode,
    HorizontalRuleNode,
    LinkNode,
    AutoLinkNode,
    ImageNode,
    MentionNode,
    BannerNode,
    BadgeNode,
    FontColorNode,
    PageBreakNode,
    EmojiNode,
    TableNode,
    TableCellNode,
    TableRowNode,
    LayoutItemNode,
    LayoutContainerNode,
    CollapsibleContainerNode,
    CollapsibleTitleNode,
    CollapsibleContentNode,
    YouTubeNode,
    FigmaNode,
    CodeNode,
    CodeHighlightNode,
    AttachmentNode,
    CustomParagraphNode,
    {
        replace     : ParagraphNode,
        with        : (node: ParagraphNode) => {
            return new CustomParagraphNode()
        },
        withKlass   : CustomParagraphNode
    }
]